module.exports = __webpack_public_path__ + "static/media/addImage-icon.fe4cc2cc.png";